import React, { useCallback, useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Routes from '~/routes/Routes'
import FirestoreService from '~/services/Firebase/Firestore'
import { StoreConnectRedux } from '~/store/ducks/StoreDuck'
import Preappointment from '../PreAppointment'
import PrescriptionList from '../PrescriptionList'
import WaitingPayment from '../WaitingPayment'
import FinanceHash from '../Finance/FinanceHash'

const Container = ({ setConfig }) => {
    const service = useCallback(() => new FirestoreService())

    useEffect(() => {
        service()
            .on('config/web')
            .subscribe(setConfig)
    }, [])

    return (
        <BrowserRouter basename="">
            <Switch>
                {Routes.filter(e => !!e.path).map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact
                        component={route.component}
                    />
                ))}
                <Route path="/prescricao" exact component={PrescriptionList} />
                <Route
                    path="/aguardando-pagamento"
                    exact
                    component={WaitingPayment}
                />
                <Route
                    path="/aguardando-pagamento/:id"
                    exact
                    component={WaitingPayment}
                />
                <Route
                    path="/pre-agendamento/:code/:id"
                    exact
                    component={Preappointment}
                />
                <Route path="/financeiro/:hash" exact component={FinanceHash} />
            </Switch>
        </BrowserRouter>
    )
}

export default StoreConnectRedux()(Container)
